import React from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { useIsSmallerThan } from 'src/hooks/useIsSmallerThan'
import Counter from 'src/components/Counter/Counter'
import {
    roles,
    zeroCredits
} from 'training-lane-booking-shared/utilities/constants'
import counterContainerClasses from './CounterContainer.module.scss'

const CounterContainer = ({
    typesArray,
    currentIndex,
    onList = false,
    adminMemberList = false,
    adminView = false,
    credits,
    firebaseProfileIsLoaded,
    handleCounterClick,
    disabled = false,
    landingPage = false
}) => {
    const isMedium = useIsSmallerThan(1280)
    const roleId = useSelector(state => state.firebase.profile?.token?.claims?.roleId)

    return typesArray.reduce((counterCollector, type, i) => {
        const newCategory = i > 0 ? typesArray[i-1].description.categoryShort !== type.description.categoryShort : false

        if ((i === 0 || newCategory) && !onList) {
            const titleClasses = classNames(
                `col-${isMedium && roles.vip.id === roleId ? 3 : 2}`,
                counterContainerClasses.counterContainerTitle,
                {
                    [counterContainerClasses.counterContainerTitleLanes]: type.category === 'lane',
                    [counterContainerClasses.counterContainerTitleIr]: type.category === 'ir'
                }
            )
            counterCollector.push(
                <div
                    key={`${type.id}-title`}
                    className={titleClasses}
                >{
                    type.category === 'lane'
                        ? type.description.short
                        : type.description.shorter
                }
                </div>
            )
        }

        counterCollector.push(
            <Counter
                adminView={adminView}
                adminMemberList={adminMemberList}
                creditsLoading={!firebaseProfileIsLoaded}
                credits={credits ?? zeroCredits}
                key={type.id}
                type={type}
                currentIndex={currentIndex}
                handleCounterClick={handleCounterClick}
                typesLength={typesArray.length}
                disabled={disabled}
                landingPage={landingPage}
            />
        )
        return counterCollector
    }, [])
}

export default CounterContainer
